export default __webpack_public_path__ + "static/media/image5.7bdbe9e7.png";